import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ValueAddOneTypeAdapter } from './dto/value-addition-one.adapter';
import { ValueAdditionOneType } from './value-addition-one.entity';
import { ValueAddition1TypesController } from './value-addition1-types.controller';
import { ValueAddition1TypesService } from './value-addition1-types.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ValueAdditionOneType]),
  ],
  controllers: [ValueAddition1TypesController],
  providers: [ValueAddition1TypesService,ValueAddOneTypeAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ValueAddition1TypesService],
})
export class ValueAddition1TypesModule {}LogsService
